import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isEqual } from 'lodash-es';
import { toNum } from '@shared/helpers/math.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import {
    getSchedaCoopSocialiControl,
    requiredByScSocObbl,
    schedaCoopSocialiCkHelper,
} from './helpers/scheda-coop-sociali-form-validators.helper';

export const schedaCoopSocialiBaseRules: FormGroupRules = {
    my_CkDenom: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkDenom');
    },

    my_CkServSocioSanit: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkServSocioSanit');
    },

    my_CkAgricolo: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkAgricolo');
    },

    my_CkIndustr: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkIndustr');
    },

    my_CkComm: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkComm');
    },

    my_CkServiz: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkServiz');
    },

    my_CkPlurimo: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkPlurimo');
    },

    my_CkSociVolontari: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkSociVolontari');
    },

    my_SociVolontariMaschi: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_SociVolontariMaschi');
    },

    my_SociVolontariFemmine: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_SociVolontariFemmine');
    },

    my_CkIscrAlboCoopSoc: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkIscrAlboCoopSoc');
    },

    my_MotiviIscriz: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_MotiviIscriz');
    },

    my_CkCoopInquadrata: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkCoopInquadrata');
    },

    my_CkAmmessiSociFinanz: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkAmmessiSociFinanz');
    },

    my_CkTrattasiDiConsorzio: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkTrattasiDiConsorzio');
    },

    my_CkOnlus: (form: FormGroup) => {
        requiredByScSocObbl(form, 'my_CkOnlus');
    },

    my_CkSezSociVolont: (form: FormGroup) => {
        ckSociVolontariHelper(form, 'my_CkSezSociVolont');
    },

    my_CkSociAssicurati: (form: FormGroup) => {
        ckSociVolontariHelper(form, 'my_CkSociAssicurati');
    },

    my_CkVolontRimborso: (form: FormGroup) => {
        ckSociVolontariHelper(form, 'my_CkVolontRimborso');
    },

    my_PercentSociVolont: (form: FormGroup) => {
        const control = getSchedaCoopSocialiControl(form, 'my_PercentSociVolont');
        const my_ScSocObbl: string = getSchedaCoopSocialiControl(form, 'my_ScSocObbl').value;
        const errors = control.errors ?? {};

        addRemoveError(toNum(control.value) > 1 && my_ScSocObbl === '1', errors, 'my_PercentSociVolont', {
            status: 'Valore eccessivo del numero di volontari',
            message: 'Il numero dei soci volontari non può superare il totale dei soci',
        });

        control.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_MotiviRimborso: (form: FormGroup) => {
        const my_CkSociVolontari = getSchedaCoopSocialiControl(form, 'my_CkSociVolontari').value;
        schedaCoopSocialiCkHelper(form, 'my_MotiviRimborso', 'my_CkVolontRimborso', 0, my_CkSociVolontari === '1');
    },
};

/** Required when my_CkSociVolontari = 1 AND my_ScSocObbl = 1 */
const ckSociVolontariHelper = (form: FormGroup, targetPath: string): void => {
    schedaCoopSocialiCkHelper(form, targetPath, 'my_CkSociVolontari', 1);
};
